/* eslint-disable */
import React, { useState, useCallback, useEffect, useRef } from 'react';
import type { FC } from 'react';
import {Alert, Box, Collapse, Container, Grid, Typography} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import useIndicators from 'src/hooks/useIndicators';
import useAuth from 'src/hooks/useAuth';
import useIsMountedRef from '../../hooks/useIsMountedRef';
import DatePicker, {registerLocale} from "react-datepicker";
import es from "date-fns/locale/es";
registerLocale("es",es);
import { useStyles } from 'src/components/dashboard/style';
import 'react-datepicker/dist/react-datepicker.css'
import WidgetTile from 'src/components/dashboard/overview/masterOverview/ComponentesPrior/WidgetTile';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import WidgetBalance from 'src/components/dashboard/overview/masterOverview/ComponentesPrior/WidgetBalance';
import TablaFinanciera from 'src/components/dashboard/overview/masterOverview/Tablas/TablaFinanciera';
import WidgeTwoColumns from 'src/components/dashboard/overview/masterOverview/ComponentesPrior/WidgeTwoColumns';
import ChartUtilidadNeta from 'src/components/dashboard/overview/masterOverview/Charts/ChartUtilidadNeta';
import ChartDeficit from 'src/components/dashboard/overview/masterOverview/Charts/ChartDeficit';
import ChartCambiosCapitalTrabajo from 'src/components/dashboard/overview/masterOverview/Charts/ChartCambiosCapitalTrabajo';
import TablaFinSmall from "../../components/dashboard/overview/masterOverview/Tablas/TablaFinSmall";
import ChartLineBar from "../../components/dashboard/overview/masterOverview/Charts/ChartLineBar";
import {getZazacorpPrediction} from "../../components/bridges/BridgeBusiness";
import {addDays} from "date-fns";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import viewMoreIcon from "../../assets/icons/viewMorePlainIcon.svg";
import flujoEfectivoIcon from "../../assets/icons/flujoEfectivoIcon.svg";

const OverviewEstadoFlujoEfectivo: FC = () => {
  const classes = useStyles();
  const { getDashboardMaster, dashboardMaster, getTradeByBusiness } =
    useIndicators();
  const isMountedRef = useIsMountedRef();
  const { user } = useAuth();
  const [info, setInfo] = useState<any>();
  const [valueUtilidadNeta, setValueUtilidadNeta] = useState([]);
  const { t } = useTranslation('dashboard');
  const date = new Date();
  let nextDate = new Date(date)
  nextDate.setFullYear(date.getFullYear() +1)
  const utc = date.getTime() + date.getTimezoneOffset() * 60000;
  const nd = new Date(utc + 3600000 * -5);
  const now = `${nd.getFullYear()}-${nd.getMonth() + 1}-${nd.getDate()}`;
  const topRef = useRef(null);
  const bottomRef = useRef(null);
  const [goingUp, setGoingUp] = useState(false);
  const [displayAlert, setDisplayAlert] = useState(true);
  const prevScrollY = useRef(
    topRef.current !== null &&
      topRef.current.getBoundingClientRect() !== undefined
      ? topRef.current.getBoundingClientRect().y
      : 0
  );
  let today = new Date()
  let tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  const [valueDate, setvalueDate] = useState(tomorrow);
  const [openTable, setOpenTable] = useState(false);
  const [dataFlujo, setDataFlujo] = useState({});
  const [dataTablaFinanciera, setDataTablaFinanciera] = useState({header:[], rows:[]});
  const [EFValues, setEFValues] = useState({
    Feo: 0,
    Fei: 0,
    Fef: 0,
    Cne: 0});

  const executeScroll = () => {
    if (goingUp) {
      if (topRef.current === null) return;
      topRef.current.scrollIntoView();
      setGoingUp(false);
    } else if (!goingUp) {
      if (bottomRef.current === null) return;
      bottomRef.current.scrollIntoView();
      setGoingUp(true);
    }
  };

  const handleScroll = () => {
    if (topRef.current === null) return;
    const currentScrollY = topRef.current.getBoundingClientRect().y;
    if (prevScrollY.current < currentScrollY && goingUp) {
      setGoingUp(false);
    }
    if (prevScrollY.current > currentScrollY && !goingUp) {
      setGoingUp(true);
    }
    prevScrollY.current = currentScrollY;
  };

  const EtlStatus = async () => {
    try {
      if (user['rolDesc'] === 'master' || user['rolDesc'] === 'estandar') {
        const obj = {
          businessId: user.businessId.business_id,
          date: now,
        };
        await getDashboardMaster();
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    EtlStatus();
  }, []);

  useEffect(() => {
    setInfo(dashboardMaster);
  }, [dashboardMaster]);

  useEffect(() => {
    window.addEventListener('wheel', handleScroll);

    return () => window.removeEventListener('wheel', handleScroll);
  }, [goingUp]);

  const onIdle = () => {
    window.location.reload();
  };

  const handleOnDateChange = (date: any) => {
    setvalueDate(date);
  }

  const handleOpenTable = (newValue) => {
    setOpenTable(prevState => !prevState);
  };

  const buildGraph = async (data) => {
    const fechaBase = new Date(valueDate);
    const length = data.header.length;
    let datesArray = [];
    let tmpFEO = [];
    let tmpFEI = [];
    let tmpFEF = [];
    let tmpCNE = [];
    for (let i = 0; i < length; i++) {
      let futureDate = new Date(fechaBase.getFullYear(), fechaBase.getMonth(), fechaBase.getDate() + i);
      datesArray.push(futureDate.getTime());
    }
    await Promise.all(data.rows.map(async (row) => {
      if (row.data[0] === "Flujo de Efectivo de las Operaciones") {
        const [, ...restOfData] = row.data;
        datesArray.map((date, index) => {
          const tmpData = [date, restOfData[index]];
          tmpFEO.push(tmpData);
        })
      } else if (row.data[0] === "Flujo de Efectivo de las Inversiones") {
        const [, ...restOfData] = row.data;
        datesArray.map((date, index) => {
          const tmpData = [date, restOfData[index]];
          tmpFEI.push(tmpData);
        })
      } else if (row.data[0] === "Flujo de Efectivo de Financiamiento") {
        const [, ...restOfData] = row.data;
        datesArray.map((date, index) => {
          const tmpData = [date, restOfData[index]];
          tmpFEF.push(tmpData);
        })
      } else if (row.data[0] === "Cambio Neto en Efectivo 1") {
        const [, ...restOfData] = row.data;
        datesArray.map((date, index) => {
          const tmpData = [date, restOfData[index]];
          tmpCNE.push(tmpData);
        })
      }
    }));
    const tmpValues = {
      ['Flujo de Efectivo de las Operaciones']: tmpFEO,
      ['Flujo de Efectivo de las Inversiones']: tmpFEI,
      ['Flujo de Efectivo de Financiamiento']: tmpFEF,
      ['Cambio Neto de Efectivo']: tmpCNE,
    };
    setDataFlujo(tmpValues);
  }

  const buildZazacorpTableJson = async (data) => {
    // Identificar todos los encabezados de fecha únicos en los datos
    let headerDates = [];
    data.forEach(item => {
      Object.keys(item).forEach(key => {
        const parts = key.split('_');
        if (parts.length === 2 && !isNaN(Number(parts[1]))) {
          if (!headerDates.includes(key)) {
            headerDates.push(key);
          }
        }
      });
    });
    // headerDates.sort(); // Para ordenar las fechas

    // Transformar las claves de fecha en fechas formateadas
    // const fechaBase = new Date(data[0].fecha_desde);
    const fechaBase = new Date(valueDate);
    let currentDate = fechaBase;
    const formattedDates = headerDates.map((date, index) => {
      if (index === 0) {
        return "Hoy"; // Primer encabezado como 'Today'
      }
      const day = parseInt(date.split('_')[1], 10);
      const newDate = addDays(currentDate, 1);
      currentDate = newDate;
      return `${newDate.getDate().toString().padStart(2, '0')}/${(newDate.getMonth() + 1).toString().padStart(2, '0')}/${newDate.getFullYear()}`;
    });


    // Crear un mapa para mantener referencias a las filas basadas en índices
    const indexToRowMap = new Map();

    // Crear la estructura de filas y subfilas
    const rows = [];

    data.forEach(item => {
      const rowData = [item.name, ...headerDates.map(date => item[date] === null ? 0 : item[date])];

      const indexParts = item.index.split('.');
      const row = { data: rowData, subRows: [] };
      indexToRowMap.set(item.index, row);

      if (indexParts.length === 1) {
        // Es una categoría principal
        rows.push(row);
      } else {
        // Es una subcategoría
        const parentIndex = indexParts.slice(0, -1).join('.');
        const parentRow = indexToRowMap.get(parentIndex);
        if (parentRow) {
          parentRow.subRows.push(row);
        }
      }
    });

    return {header: formattedDates, rows};
  };

  const dataTablaFinancieras = {
    header: [
      'Hoy',
      '05/06/2024',
    ],
    rows: [
      {
        data: ["Utilidad Neta", 1, 2],
        subRows: [],
      },
      {
        data: ["Depreciación y Amortización", 1, 2],
        subRows: [],
      },
      {
        data: ["Cambios en el Capital de Trabajo", 1, 2],
        subRows: [],
      },
      {
        data: ["Flujo de Efectivo de las Operaciones", 1, 2],
        subRows: [],
      },
      {
        data: ["Flujo de Efectivo de las Inversiones", 1, 2],
        subRows: [],
      },
      {
        data: ["Flujo de Efectivo del Financiamiento", 1, 2],
        subRows: [],
      },
      {
        data: ["Cambios Netos de Efectivo", 1, 2],
        subRows: [],
      },
    ],
  };

  async function getPredictions() {
    try {
      const formattedDate = valueDate.toISOString().split('T')[0];
      const response = await getZazacorpPrediction(formattedDate,formattedDate,'efe_predict');
      const tableJson = await buildZazacorpTableJson(response.resultRangeDates);
      const tableData = await buildZazacorpTableJson(response.result7Days);
      setDataTablaFinanciera(tableData);
      console.log("tabljsonEFE", tableJson)
      const FEO = tableJson.rows.filter(row => row.data[0] === "Flujo de Efectivo de las Operaciones")[0].data;
      const FEI = tableJson.rows.filter(row => row.data[0] === "Flujo de Efectivo de las Inversiones")[0].data;
      const FEF = tableJson.rows.filter(row => row.data[0] === "Flujo de Efectivo de Financiamiento")[0].data;
      const CNE = tableJson.rows.filter(row => row.data[0] === "Cambio Neto en Efectivo 1")[0].data;
      const tmpValues = {
        Feo: FEO[1],
        Fei: FEI[1],
        Fef: FEF[1],
        Cne: CNE[1],
      };
      setEFValues(tmpValues);
      const graphJson = await buildZazacorpTableJson(response.resultUntilEndYear);
      buildGraph(graphJson);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getPredictions();
  }, [valueDate]);

  return (
    <div>
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      minHeight: "95vh",
      backgroundColor: "background.default",
    }}
  >
    <Container maxWidth={false} sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
      <Box sx={{ flexGrow: 1, paddingTop: 2 }}>
        <Grid container justifyContent="space-between" spacing={3}>
          {/* Uncomment to use alert */}
          {/* <Grid item xs={12} md={12}>
            <Collapse in={displayAlert}>
              <Alert severity="warning" variant="outlined" sx={{ bgcolor: 'background.paper' }} onClose={() => { setDisplayAlert(false); }}>
                Alerta de Estado Flujo Efectivo
              </Alert>
            </Collapse>
          </Grid> */}

          <Grid item xs={12} md={10} display="flex" alignItems="center" sx={{ paddingTop: '7px' }}>
            <LocalAtmIcon sx={{ color: '#001930' }} fontSize="medium" />
            <Typography
              sx={{
                paddingLeft: 1,
                fontWeight: 700,
                fontSize: '1.825rem',
              }}
              color="textSecondary"
            >
              Estado de Flujo de Efectivo Proforma
            </Typography>
            <Box ml={1} onClick={() => handleOpenTable(true)} sx={{ cursor: 'pointer', alignSelf: 'end' }}>
              <img src={viewMoreIcon} alt="costos x ventas" width="35px" height="35px" />
            </Box>
          </Grid>

          <Grid item xs={12} md={2} display="flex" alignItems="center">
            <Typography color="#42526E" fontWeight={500} mr={1} display="flex">Fecha</Typography>
            <DatePicker
              minDate={new Date()}
              maxDate={nextDate}
              selected={valueDate}
              locale="es"
              onChange={handleOnDateChange}
              dateFormat="yyyy-MM-dd"
              className={classes.datePicker}
            />
          </Grid>

          {openTable === true ? (
            <Grid item xs={12}>
              <div ref={bottomRef}>
                <TablaFinanciera data={dataTablaFinanciera} openTable={handleOpenTable} title="Estado de Flujo de Efectivo" />
              </div>
            </Grid>
          ) : (
            <>
              <Grid container>
                <Grid item xs={12} md={12}>
                  <Grid container spacing={2} my={2}>
                    <Grid item xs={3}>
                      <WidgetTile
                        topSubtitle="Flujo de Efectivo de las Operaciones"
                        icon={<img src={flujoEfectivoIcon} alt="costos x ventas" width="35px" height="35px" />}
                        value={EFValues.Feo}
                        backgroundBlue={false}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <WidgetTile
                        topSubtitle="Flujo de Efectivo de las Inversiones"
                        icon={<img src={flujoEfectivoIcon} alt="costos x ventas" width="35px" height="35px" />}
                        value={EFValues.Fei}
                        backgroundBlue={false}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <WidgetTile
                        topSubtitle="Flujo de Efectivo de Financiamiento"
                        icon={<img src={flujoEfectivoIcon} alt="costos x ventas" width="35px" height="35px" />}
                        value={EFValues.Fef}
                        backgroundBlue={false}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <WidgetTile
                        topSubtitle="Cambio Neto de Efectivo"
                        icon={<img src={flujoEfectivoIcon} alt="costos x ventas" width="35px" height="35px" />}
                        value={EFValues.Cne}
                        backgroundBlue={false}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={12}>
                  <ChartLineBar flujoEfectivo={dataFlujo} />
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Box>

      <Box component="footer" sx={{ py: 2,}}>
        <Typography  sx={{ fontSize: '1rem' }}>© 2025 Dynamics Within. Todos los Derechos Reservados.</Typography>
      </Box>
    </Container>
  </Box>
</div>
  );
};

export default OverviewEstadoFlujoEfectivo;


